import { Store, StoreAvailability } from '../types/store';

export const SUBSCRIBE_TO_STORE_UPDATES_CUSTOM_EVENT = 'kmxSubscribeToMyStoreModuleUpdates';
export const SET_STORE_CUSTOM_EVENT = 'kmxUpdateMyStoreModuleByStore';
export const SET_STORE_BY_ID_CUSTOM_EVENT = 'kmxUpdateMyStoreModuleById';
export const SET_STORE_BY_ID_ONLOAD_CUSTOM_EVENT = 'kmxUpdateMyStoreModuleByIdOnLoad';
export const OPEN_STORE_SELECTION_MODAL_EVENT = 'kmxOpenStoreSelectionModal';
export const CLOSE_STORE_SELECTION_MODAL_EVENT = 'kmxCloseStoreSelectionModal';
export const SET_COGNITIVE_SEARCH_EVENT = 'kmxEnableCognitiveSearch';
export const ENABLE_SEARCH_BAR_DISPLAY_TEST = 'kmxEnableSearchBarDisplayPromptTest';

export const EMPTY_STORE: Store = {
    Id: '',
    Name: '',
    PhoneNumbers: [],
    Hours: [],
    PhoneHours: [],
    ServiceHours: [],
    Latitude: 0,
    Longitude: 0,
    AddressLine1: '',
    AddressLine2: '',
    City: '',
    MailingCity: '',
    StateAbbreviation: '',
    ZipCode: '',
    HolidayHours: [],
    ActiveStatus: '',
    AlertMessage: '',
    Capabilities: [],
    DistanceInMiles: 0,

    // `legacy` fields as of 12.2021:
    IsSaveable: true,
    IsCarBuyingCenter: false,
};

export const DEFAULT_STORE_AVAILABILITY: StoreAvailability = {
    Id: '',
    IsOpen: false,
    CurrentHours:[],
    Holiday: [],
    Alert: { locationStatus: '', message: '', locationId: '' }
}

export const GRAND_OPENING_ACTIVE_STATUS = 'Grand Opening';

export const SEARCH_BAR_TEST = 'SearchBar';
export const COGNITIVE_SEARCH_TEST = 'CognitiveSearch';
